export default function(instance) {
    return {
        getAll(params) {
            return instance.get('/api/v2/ieo/songs', { params })
        }
    }
}